__turbopack_context__.v({
  "autocompleteitem": "search-widget-module-scss-module__DCTkKG__autocompleteitem",
});
